import Work1 from "../../assets/project1.png";
import Work2 from "../../assets/project2.png";
import Work3 from "../../assets/project3.png";
import Work5 from "../../assets/project5.png";
import Work6 from "../../assets/project6.png";
import Work7 from "../../assets/project7.png";
import Work8 from "../../assets/project8.png";
import Work9 from "../../assets/project9.png";

export const projectsData = [

  {
    id: 1,
    image: Work3,
    title: "Sports Odds Predictor - Python/ML",
    linktext: "Source Code",
    category: "ML and AI",
    url: "https://github.com/fabio-trajano/sports-odds-predictor"
  },
  {
    id: 2,
    image: Work1,
    linktext: "Source Code",
    title: "PocketSommelier - RubyOnRails",
    category: "Others",
    url: "https://github.com/AndreNelas93/pocketsommelier"
  },
  {
    id: 3,
    image: Work8,
    linktext: "Source Code",
    title: "Outfit Size Recommender - Python/ML",
    category: "ML and AI",
    url: "https://github.com/fabio-trajano/outfit-size-finder"
 },
  {
     id: 4,
     image: Work6,
     linktext: "Source Code",
     title: "Chess Backend - Java/SpringBoot",
     category: "Backend",
     url: "https://github.com/fabio-trajano/chess-java"
  },
  {
    id: 5,
    image: Work7,
    linktext: "Source Code",
    title: "Ticker Analysis - Java",
    category: "Backend",
    url: "https://github.com/fabio-trajano/java-financial-analysis"
  },
  {
    id: 6,
    image: Work9,
    linktext: "Source Code",
    title: "Simple AI Music Generator - Python",
    category: "ML and AI",
    url: "https://github.com/fabio-trajano/simple-music-gen-ai.git"
  },
  {
    id: 7,
    image: Work5,
    title: "Restaurant API - Python/Django",
    linktext: "Source Code",
    category: "Backend",
    url: "https://github.com/fabio-trajano/Meta-backend-capstone-project/tree/master/MetaCapstoneProject"
  },
  {
    id: 8,
    image: Work2,
    linktext: "Source Code",
    title: "Petbnb RubyOnRails",
    category: "Others",
    url: "https://github.com/AndreNelas93/petbnb"
  },
];

// projects
export const projectsNav = [
  {
    name: "All",
  },
  {
    name: "Backend",
  },
  {
    name: "ML and AI",
  },
  {
    name: "Others",
  },
];
